<template>
  <div class="docItem">
     <div class="doc-item"  
          @touchstart='touchStart'
          @touchmove='touchMove'
          @touchend='touchEnd'
          :style="deleteSlider">
        <div class="doc-mobile-model" v-if="o.status == 2" @click="openPDF(o.id)"></div>
        <div class="canvas-box"  v-if="canvas" >
              <canvas class="canvas"
                ref="canvas"
                width="50" height="50"></canvas>
        </div>
        <img class="doc-img"  :src = "o.doc_img" alt="" />
        <a   target="_blank"
             v-if="o.status == 2"
             @click="handleOpen(o.id,o.status)"
             :class="['doc-name', 'ellipsis' ,'en-doc-list-name',{'isEngCss':isChinese}]">{{o.filename}}</a>
<a   target="_blank" v-if="o.status != 2" 
          :class="['doc-name', 'ellipsis', 'no-hover', 'en-doc-list-name',{'isEngCss': isChinese}]">{{o.filename}}</a>
        <div class="doc-page-num">{{o.doc_size}}</div>
        <div class="doc-tanstype">{{o.trans_type}}</div>
        <div class="doc-status">{{o.status_text}}</div>
        <div class="doc-time">{{o.created_at}}</div>
        <div class="href-download">
            <div
              :href="o.download_link"
              @click="handleConfirm(o.id,1)"
              v-if="o.status ==2 || o.status==4">{{$t('global.down.word')}}</div>
            <div
              :href="o.download_link"
              @click="handleConfirm(o.id,2)"
              v-if="o.status ==2">{{$t('global.down.pdf')}}</div>
            <div
              v-if="o.status !=2&&o.preview_status==2">
              <a @click="handleOpen(o.id,o.preview_status)"
                 target="_blank">{{$t('global.down.preview')}}</a></div>
            <div
              v-if="o.status == 2">
              <a @click="handleOpen(o.id,o.status)"
                target="_blank">{{$t('global.down.read')}}</a></div>
        </div>
        <div class="doc-del" @click="deleItem(o.id,o.filename)"></div>
     </div>
     <div class="remove" ref='remove' @click="deleItem(o.id,o.filename)"></div>
  </div>
</template>
<style scoped>
    @import "../css/list-item.scss";
    .canvas-box{
      display: none;
      position: absolute;
      z-index: 10;
      left: 4px;
      top: 20px;
      width: 60px;
      height: 70px;
      background:rgba(0,0,0,0.4);
    }
    .canvas{
       position: absolute;
       left:50%;
       top:50%;
       transform: translate(-50%,-50%);
    }
    .doc-name.no-hover{
      cursor: default;
    }
    .doc-name.no-hover:hover{
      color: #666666;
    }
    .docItem{
      position: relative;
      /* border-bottom: 1px solid #BFBFBF; */
      height: 110px;
      cursor: default;
      font-size: 14px;
      transition: 0.3s;
    }
    .doc-item{
      position: absolute;
      left: 0;
      border-bottom: none;
      height: 100%;
      top: 0;
      padding: 0;
      right: 0;
      -webkit-transition: 0.3s;
      transition: 0.3s;
      z-index: 100;
      background: #fff;
    }
    .remove{
      display: none;
      position: absolute;
       width: 65px;
       height: 100%;
       background: #BFBFBF;
       right: 0;
       top: 0;
       text-align: center;
       font-size: 40px;
       line-height: 200px;
       background: url('../assets/del-icon.png') no-repeat;
       background-size: 20px 20px;
       background-position: center center;
       bottom: 0;
       margin-right: -10px;
    }
    .doc-mobile-model{
      display: none;
    }



  .format-group {
    text-align: center !important;
    margin: auto !important;
    display: block !important;
  }

  .el-radio__label {
    font-size: 16px !important;
  }
  .doc-item .href-download,.doc-item .doc-time{
    transition:color 0.4s ,right 0.4s;
    -webkit-transition: color 0.4s,right 0.4s;
    background: rgba(255,255,255,.9);
  }
  /* .doc-item:hover .href-download,.doc-item:hover  .doc-time{
    right:60px;
  } */
  .doc-item .doc-status{
    opacity: 1;
    transition:  opacity 0.1s;
     -webkit-transition: opacity 0.1s;
  }
  .doc-item .doc-del{
    transition:opacity 0.4s;
    -webkit-transition:opacity 0.4s;
    /* opacity: 0; */
    display: block;
    position: absolute;
    top: 78px;
    right: 0px;
  }
  /* .doc-item:hover .doc-del{
    opacity: 1;
  } */
  .doc-item:hover .doc-del:after{
    opacity: 1;
    left: -15px;
  }
  .doc-del:after{
     /* left: 0; */
    /* position: absolute;
   
    display: block;
    content: '';
    height: 50px;
    width: 1px;
    background: #BFBFBF;
    top: -12px;
    opacity: 0;
    transition:opacity 0.8s,left 0.4s;
    -webkit-transition:opacity 0.8s,left 0.4s; */
  }
  .remove::after{
    position: absolute;
    display: block;
    content: '';
    left: 5px;
    height: 50px;
    width: 1px;
    background: #BFBFBF;
    top: 50%;
    transform: translateY(-50%);
  }
  .doc-time{
    right:30px;
    top: 70px;
  }
    @media (max-width: 650px) {
      .canvas-box{
        display: block;
      }
      .doc-item:hover .doc-status{
        opacity: 0;
      }
     .doc-item:hover .doc-status{
          opacity: 1;
      }
      .doc-item:hover .href-download,.doc-item:hover  .doc-time{
          right: 0;
        }
          .doc-item .doc-del{
            display: none;
          }
        .docItem{
          height: 118px;
          padding: 1.30rem 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          padding-left: 3.90rem;
        }
        .doc-mobile-model{
          display: block;
          position: absolute;
          z-index: 1000;
          left: 0;
          top: 0;
          right: 65px;
          bottom: 0;
        }
        .doc-item{
         right:0;
        }
        .remove{
          display: block;
        }
    }
</style>
<script>
  import config from '../config/config';
  let time_canvas;
  export default {
    name: "DocItem",
    data() {
      return {
        startX:0,   //触摸位置
        endX:0,     //结束位置
        moveX: 0,   //滑动时的位置
        disX: 0,    //移动距离
        deleteSlider: '',//滑动时的效果,使用v-bind:style="deleteSlider"
      };
    },
    mounted (){
        
    },
    props:{
      o:{},
      canvas:false,
      isChinese:false,
    },
    created(){
    
    },
    methods: {
        openPDF:function(doc_id) {
           this.$emit('payItem',{doc_id:doc_id,type:'pdf'});
          // window.location.href =  config.TRS_URL + "/v1/doc/" + doc_id + "/download?type=pdf&date="+Date.parse(new Date());
        },
        handleConfirm: function(id,type) {
          const fType = type ==1? 'doc':'pdf';
           this.$emit('payItem',{doc_id:id,type:fType});
          // window.location.href = config.TRS_URL + "/v1/doc/" + id + "/download?type=" + fType +'&time='+Date.parse(new Date());
        },
        handleOpen:function (id,status) {
          console.log(status)
          if(status==2){
            let routeData = this.$router.resolve({ path: '/pdf_view/'+id });
            window.open(routeData.href, '_blank');
          }
        },
        deleItem(id,filename){
          this.$emit('refDelItem',{id:id,filename:filename});
          this.deleteSlider = "transform:translateX(0px)";
        },
        touchStart(ev){
          if(this.canvas){
            return;
          }
          ev= ev || event
          //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
    
          if(ev.touches.length == 1){
            // 记录开始位置
            this.startX = ev.touches[0].clientX;
          }
        },
        touchMove(ev){
          if(this.canvas){
            return;
          }
          ev = ev || event;
          //获取删除按钮的宽度，此宽度为滑块左滑的最大距离
          let wd=this.$refs.remove.offsetWidth;
          if(ev.touches.length == 1) {
            // 滑动时距离浏览器左侧实时距离
            this.moveX = ev.touches[0].clientX
            //起始位置减去 实时的滑动的距离，得到手指实时偏移距离
            this.disX = this.startX - this.moveX;
            // 如果是向右滑动或者不滑动，不改变滑块的位置
            if(this.disX < 0 || this.disX == 0) {
              this.deleteSlider = "transform:translateX(0px)";
              // 大于0，表示左滑了，此时滑块开始滑动 
            }else if (this.disX > 0) {
              //具体滑动距离我取的是 手指偏移距离*5。
              this.deleteSlider = "transform:translateX(-" + this.disX*5 + "px)";
              // 最大也只能等于删除按钮宽度 
              if (this.disX*5 >=wd) {
                this.deleteSlider = "transform:translateX(-" +wd+ "px)";
              }
            }
          }
        },
        touchEnd(ev){
          ev = ev || event;
          let wd=this.$refs.remove.offsetWidth;
          if (ev.changedTouches.length == 1) {
            let endX = ev.changedTouches[0].clientX;                      
            this.disX = this.startX - endX;
            //如果距离小于删除按钮一半,强行回到起点            
            if ((this.disX*5) < (wd/2)) {
              this.deleteSlider = "transform:translateX(0px)";
            }else{
              //大于一半 滑动到最大值
              this.deleteSlider = "transform:translateX(-"+wd+ "px)";
            }
          }
        } ,
        outUseCanvas(num){
          this.canvasCircle(this.$refs.canvas, num,"#fff",'rgba(0,0,0,0.4)');
        },
        canvasCircle(drawing_elem, percent, forecolor, bgcolor) {
            var context = drawing_elem.getContext("2d");
            var center_x = drawing_elem.width / 2;
            var center_y = drawing_elem.height / 2;
            var rad = Math.PI*2/100;
            var speed = 0;
            var lineWidth = 4;
            function backgroundCircle(){
                context.save();
                context.beginPath();
                context.lineWidth = lineWidth; //设置线宽
                var radius = center_x - context.lineWidth;
                context.lineCap = "round";
                context.strokeStyle = bgcolor;
                context.arc(center_x, center_y, radius, 0, Math.PI*2, false);
                context.stroke();
                context.closePath();
                context.restore();
            }
            //绘制运动圆环
            function foregroundCircle(n){
                context.save();
                context.strokeStyle = forecolor;
                context.lineWidth = lineWidth;
                context.lineCap = "round";
                var radius = center_x - context.lineWidth;
                context.beginPath();
                context.arc(center_x, center_y, radius , -Math.PI/2, -Math.PI/2 +n*rad, false); //用于绘制圆弧context.arc(x坐标，y坐标，半径，起始角度，终止角度，顺时针/逆时针)
                context.stroke();
                context.closePath();
                context.restore();
            }
            //绘制文字
            function text(n){
                context.save(); //save和restore可以保证样式属性只运用于该段canvas元素
                context.fillStyle = forecolor;
                var font_size = 14;
                context.font = 'bold '+font_size + "px Helvetica";
                context.textAlign = 'center';
                context.textBaseline = 'middle';
                // var text_width = context.measureText(n.toFixed(0)+"%").width;
                context.fillText(n.toFixed(0)+"%", center_x, center_y);
                context.restore();
            }
            (function drawFrame(){
                // window.requestAnimationFrame(drawFrame);
                context.clearRect(0, 0, drawing_elem.width, drawing_elem.height);
                backgroundCircle();
                text(percent);
                foregroundCircle(percent);
                // if(speed >= percent) return;
                // speed += 1;
            }());
        },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DocItem.vue